import React from 'react';

const fieldStyle = { fontWeight: 'bold', color: 'var(--text-secondary)' };

const formatDateTime = (value) => (
  value ? new Date(value).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }) : 'N/A'
);

// Audit metadata fields (Updated/Approved at & by) for a record's View modal.
// Renders as plain label/value blocks meant to sit inside an existing
// `gridTemplateColumns: '1fr 1fr'` details grid (see ProductMaster.js's View
// modal), not as a self-contained grid — this keeps every page's audit
// section visually identical without dictating the surrounding layout.
export default function AuditMeta({ updatedAt, updatedBy, approvedAt, approvedBy }) {
  return (
    <>
      <div>
        <label style={fieldStyle}>Last Updated</label>
        <p>{formatDateTime(updatedAt)}</p>
      </div>
      <div>
        <label style={fieldStyle}>Updated By</label>
        <p>{updatedBy || '-'}</p>
      </div>
      <div>
        <label style={fieldStyle}>Approved At</label>
        <p>{formatDateTime(approvedAt)}</p>
      </div>
      <div>
        <label style={fieldStyle}>Approved By</label>
        <p>{approvedBy || '-'}</p>
      </div>
    </>
  );
}
